import { CircularProgress } from '@mui/material'

interface LoaderProps {
  size?: 'small' | 'medium' | 'large' // define os tamanhos
  color?: 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
}

export const Loading = ({ size = 'medium', color = 'inherit' }: LoaderProps) => {
  const sizeMap = {
    small: 16,
    medium: 24,
    large: 32
  }

  return <CircularProgress size={sizeMap[size]} color={color} thickness={4} />
}
